import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';
import { ShopService } from '../configuration/services/shop.service';
import { Router } from '@angular/router';
import { window } from 'rxjs/operator/window';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css','../app.component.css'],
  providers: [AuthService,ShopService]
})
export class HomeComponent implements OnInit {
  shops:any = [];
  shopLoaded:boolean = false;
  constructor(private authService: AuthService, private router: Router, private shopService:ShopService) { }
  role:number = 3;
  reload: boolean = false;
  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
    if (localStorage.getItem('shop') != null){
      this.shopLoaded = true;
    }
    this.isLoggedIn();
    this.getShops();
  }

  getShops(){
    this.shopService.query({})
      .subscribe((shops) => {
        this.shops = shops;
      });
  }

  isLoggedIn(){
    this.authService.isLoggedIn().subscribe((response)=>{
      if(!response.isLoggedIn){
        this.router.navigate(['/login']);
      }
    })
  }

  selectShop(id,name){
    localStorage.setItem('shop',id);
    localStorage.setItem('shopName',name);
    this.reload = true;
    this.shopLoaded = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts